import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { createUseStyles } from "react-jss";

import { Colors } from "../../config";

const useStyles = createUseStyles({
  toast: {
    position: "fixed",
    top: 70,
    left: "50%",
    maxWidth: "80%",
    padding: [12, 24],
    backgroundColor: Colors.Orange,
    borderRadius: 5,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
    color: "#252525",
    fontSize: 14,
    fontWeight: "bold",
    lineHeight: "normal",
    zIndex: 200,
    opacity: props => (props.show ? 1 : 0),
    visibility: props => (props.show ? "visible" : "hidden"),
    transform: props =>
      props.show
        ? "translateX(-50%) translateY(0)"
        : "translateX(-50%) translateY(-10px)",
    transition: "opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease",
    pointerEvents: "none",
  },
});

const Toast = forwardRef((_, ref) => {
  const [message, setMessage] = useState(null);
  const timer = useRef(null);
  const classes = useStyles({ show: message !== null });

  useEffect(() => () => clearTimeout(timer.current), []);

  useImperativeHandle(ref, () => ({
    show: (msg, duration = 5000) => {
      setMessage(msg);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setMessage(null), duration);
    },
  }));

  return <div className={classes.toast}>{message}</div>;
});

export default Toast;
